import { type GetTopLensesQuery } from "../api/queries";
import { type TopLensCardState } from "../models";

export const DEFAULT_NUMBER_OF_TOP_LENSES = 5;

export const defaultTopLensCardState: Readonly<TopLensCardState> = {
    unlockableIdList: [],
    lensCards: [],
    offset: 0,
    numberOfTopLenses: DEFAULT_NUMBER_OF_TOP_LENSES,
    isFilled: false,
    isEmpty: false,
};

export const createTopLensCardState = (topLenses: GetTopLensesQuery): TopLensCardState => {
    const unlockableIdList = topLenses.getMyLensesOrganicStats.responseEntryList
        .filter((lensStats) => {
            const value = lensStats.statsResponseTimeEntryList[0]?.statsList?.[0]?.statsList?.[0]?.value;
            return !!value && Number.parseInt(value) > 0;
        })
        .map((lensStats) => lensStats.assetId);

    const numberOfTopLenses =
        unlockableIdList.length < DEFAULT_NUMBER_OF_TOP_LENSES ? unlockableIdList.length : DEFAULT_NUMBER_OF_TOP_LENSES;

    return {
        ...defaultTopLensCardState,
        unlockableIdList,
        numberOfTopLenses,
    };
};
